/*eslint-disable*/
import React, {useState, useEffect, Fragment} from "react";

import APIClient from "../client";
import config from "../config.js"
import TableChart from "../components/Charts/TableChart.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";
import UserCreatePopUp from "../components/Modals/UserCreateModal.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";
import {Link} from "react-router-dom";


const client = new APIClient(config);


export default function AdminUserList() {

    const [data, setData] = useState(null);
    const [columnData, setColumnData] = useState(null);
    const [userCreateIsOpen, setUserCreateIsOpen] = useState(false);
    const [userEdit, setUserEdit] = useState(false);
    const [userRecord, setUserRecord] = useState(false);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchUserList();
    }, []);

    const fetchUserList = () => {
        client.getUserList().then((data) => {
            setLoading(false);
            setData(data['data']['data']);
            const columns = [
                {
                    key: "action",
                    text: "Action",
                    className: "action",
                    width: 100,
                    align: "left",
                    sortable: false,
                    cell: (record) => {
                        return (
                            <Fragment>
                                <Link
                                    className="get-started text-blue rounded py-1 px-7 bg-yellow"
                                    to={"/userpermission"}
                                    state={[{"user_id": record.id, "email": record.email}]}
                                >
                                    &nbsp;
                                    <i className="fa fa-pencil" aria-hidden="true"></i>
                                    &nbsp; Edit &nbsp;
                                </Link>
                            </Fragment>
                        );
                    },
                },
                {
                    name: "email",
                    sortable: true,
                    selector: (row) => row.email,
                },
                {
                    name: "first_name",
                    sortable: true,
                    selector: (row) => row.first_name,

                },
                {
                    name: "last_name",
                    sortable: true,
                    selector: (row) => row.last_name,
                },
                {
                    name: "is_active",
                    sortable: true,
                    selector: (row) => row.is_active.toString(),
                },
                {
                    name: "is_fund_viewer",
                    sortable: true,
                    selector: (row) => row.is_fund_viewer.toString(),
                },
                {
                    name: "is_opportunity_viewer",
                    sortable: true,
                    selector: (row) => row.is_opportunity_viewer.toString(),
                },
                {
                    name: "is_superuser",
                    sortable: true,
                    selector: (row) => row.is_superuser.toString(),
                },
                {
                    name: "id",
                    omit: true,
                    selector: (row) => row.id,
                },
                {
                    name: "created_at",
                    width: "200px",
                    selector: (row) => row.created_at,
                },
            ];

            setColumnData(columns);
            setError(null);
        });
    };

    const closeModal = () => {
        setUserCreateIsOpen(false);
    };

    const handleSelection = ({selectedRows}) => {
        setUserEdit(true);
    };

    const handleSave = (updatedData) => {
        try {
             client.createUser(updatedData.email, updatedData.password, updatedData.firstName, updatedData.lastName)
                .then(() => {
                    fetchUserList();
                    closeModal();
                })
                .catch((err) => {
                    // setEditErrorMessage(err);
                    closeModal();
                });
        }
        catch (error) {
            console.log('Failed to submit map:', error);
        }
  };

    const screenSize = (window.innerWidth >= 912);
    const screenSizeTwo = (window.innerWidth >= 1024);

    document.title = "User Admin";

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">

                    {loading && (
                        <div className="text-xl font-medium">Loading...</div>
                    )}
                    {error && <CardError message={error}/>}

                    {data && (

                        <>
                            <h2 className="text-36 text-yellow mb-6">User List</h2>

                            <TableChart
                                columns={columnData}
                                data={data}
                                defaultSortFieldId={1}
                                selectableRowsSingle={true}
                                onSelectedRowsChange={handleSelection}
                                dense
                            />

                        </>


                    )}

                </div>
                <div className="text-center mt-10">

                    <button
                        className="text-16-500 px-12 py-3 ml-3 mb-3 items-center text-blue bg-yellow rounded"
                        type="button"
                        onClick={() => setUserCreateIsOpen(true)}
                    >
                        <i className="fa fa-plus" aria-hidden="true"></i>

                        &nbsp; Add User &nbsp;
                    </button>

                </div>
                <UserCreatePopUp onSave={handleSave} isOpen={userCreateIsOpen} onClose={closeModal} />
            </section>


        </>
    );
}

